export default __webpack_public_path__ + "static/media/success_password.af19aedb.svg";